require("bootstrap-daterangepicker/daterangepicker.css");

import 'bootstrap-daterangepicker';

function enableDateFields($scope) {
  function clearDate(event) {

    // don't submit the form.
    event.preventDefault();

    // find a bunch of relevant elements.
    var $dateField = $(event.target).closest('.date-input').find('input');

    // clear the cloudinary id.
    $dateField.val(null);

  }

  $scope.find('input.single-daterange').not('.future-only').daterangepicker({
    showDropdowns: true,
    minYear: new Date().getFullYear() - 100,
    maxYear: new Date().getFullYear() + 5,
    singleDatePicker: true,
    autoUpdateInput: false,
    locale: {
      cancelLabel: 'Clear',
      format: 'DD/MM/YYYY',
    }
  });
  $scope.find('input.single-daterange.future-only').daterangepicker({
    showDropdowns: true,
    minDate: new Date(),
    minYear: new Date().getFullYear(),
    maxYear: new Date().getFullYear() + 5,
    singleDatePicker: true,
    autoUpdateInput: false,
    locale: {
      cancelLabel: 'Clear',
      format: 'DD/MM/YYYY',
    }
  });

  $scope.find('input.single-daterange').on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY'));
  });

  $scope.find('input.single-daterange').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });

  $scope.find(".date-input button.clear").click(clearDate);
}

$(document).on('turbolinks:load', function() {
  enableDateFields($('body'));
})

$(document).on('sprinkles:update', function(event) {
  enableDateFields($(event.target));
})
